export async function logClientError(error, errorInfo) {
  const message = error?.message || "Unknown client error";
  const stack = error?.stack || "";
  const location = window.location.href;
  const componentStack = errorInfo?.componentStack || "";
  try {
    await fetch("/api/log-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message,
        stack,
        componentStack,
        location,
        source: "client",
      }),
    });
  } catch (err) {
    console.error("Failed to log client error:", err);
  }
}
